import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/category', label: '游戏中心' },
  { path: '/articles', label: '最新资讯' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`text-xl md:text-2xl font-heading font-bold transition-colors duration-300 ${
              scrolled ? 'text-primary-600' : 'text-white'
            }`}>
              新葡京娱乐城
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-400 ${
                  location.pathname === link.path
                    ? scrolled ? 'text-primary-600' : 'text-primary-400'
                    : scrolled ? 'text-foreground-700' : 'text-white/90'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className="px-5 py-2 text-sm font-medium whitespace-nowrap rounded-md border transition-colors duration-200 cursor-pointer"
              style={{
                borderColor: scrolled ? 'oklch(var(--primary-500))' : 'rgba(255,255,255,0.6)',
                color: scrolled ? 'oklch(var(--primary-600))' : 'white',
              }}
            >
              登录
            </a>
            <a
              href="#"
              className="px-5 py-2 text-sm font-medium whitespace-nowrap rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
            >
              立即注册
            </a>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              scrolled ? 'text-foreground-800' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-600'
                    : 'text-foreground-700'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-2 border-t border-background-200">
              <a
                href="#"
                className="flex-1 text-center px-4 py-2 text-sm font-medium whitespace-nowrap rounded-md border border-primary-500 text-primary-600 cursor-pointer"
              >
                登录
              </a>
              <a
                href="#"
                className="flex-1 text-center px-4 py-2 text-sm font-medium whitespace-nowrap rounded-md bg-primary-500 text-background-50 cursor-pointer"
              >
                立即注册
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}